import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Artikelumsatz } from './Artikelumsatz';

export const ArtikelumsatzPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const datumVon = urlSearchParams.get('datumVon') || moment().format('YYYY-MM-DD');
    const datumBis = urlSearchParams.get('datumBis') || moment().format('YYYY-MM-DD');

    const artikelGruppeNr = urlSearchParams.get('artikelGruppeNr')
        ? parseInt(urlSearchParams.get('artikelGruppeNr') || '0', 10)
        : 0;
    const artikelNr = urlSearchParams.get('artikelNr') || '';
    const showCompare = urlSearchParams.get('showCompare') === 'true';

    return (
        <Artikelumsatz
            datumVon={datumVon}
            datumBis={datumBis}
            artikelGruppeNr={artikelGruppeNr}
            artikelNr={artikelNr}
            showCompare={showCompare}
            printView
        />
    );
};
